"use client";

import { ConfigProvider } from "antd";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import MenuDrawerComponent from "./TheMenuDrawer";
import TheMenu from "./TheMenu";

const HeaderComponent = ({ menuItems }) => {
  const router = useRouter();
  const [openMenu, setOpenMenu] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Ẩn "Dự án" khỏi menu header (vẫn giữ trong menuItems gốc cho Footer nếu cần)
  const headerMenuItems = (menuItems || []).filter(
    (item) => item.slug !== "/du-an" && item.label !== "Dự án",
  );

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {},
      }}
    >
      <div
        id="main-menu"
        className="relative bg-no-repeat bg-scroll bg-cover lg:flex lg:items-center"
        style={{ boxShadow: "0px 0px 12px 0px #60626629" }}
        suppressHydrationWarning={true}
      >
        <div
          className={`
        mx-auto relative w-full max-w-[1920px] px-3 sm:px-4 md:px-8 lg:px-12 transition-all duration-300 ease-in-out
        ${isScrolled ? "py-2 sm:py-2 md:py-[10px]" : "py-3 sm:py-4 md:py-[20px]"}
      `}
        >
          <div className="flex items-center justify-between gap-2 sm:gap-4">
            <button
              type="button"
              onClick={() => {
                router.push("/");
              }}
              className="cursor-pointer flex-shrink-0"
            >
              <img
                alt="logo"
                className="logo h-8 sm:h-9 md:h-[40px] w-auto object-contain max-h-[40px]"
                src="/images/hitech.png"
              />
            </button>
            {/* Menu thu gọn (hamburger) từ mobile tới tablet (< 1024px) */}
            <div className="flex lg:hidden flex-shrink-0">
              <button
                onClick={() => setOpenMenu(true)}
                className="p-1"
                aria-label="Mở menu"
              >
                <img
                  src={"/svg/menu.svg"}
                  alt="menu"
                  width={28}
                  height={28}
                  className="filter-white w-7 h-7"
                />
              </button>
            </div>
            {/* Menu đầy đủ chỉ hiện từ desktop (>= 1024px) */}
            <div className="hidden lg:block min-w-0">
              <TheMenu menuItems={headerMenuItems} className="" />
            </div>
          </div>
        </div>
        <MenuDrawerComponent
          menuItems={headerMenuItems}
          open={openMenu}
          setClose={setOpenMenu}
        />
      </div>
    </ConfigProvider>
  );
};

export default HeaderComponent;
